var map = {
	"./3Crv-logo.png": 1385,
	"./AAVE-logo.png": 1386,
	"./COMP-logo.png": 1387,
	"./CRV-logo.png": 1388,
	"./DAI-logo.png": 1389,
	"./ETH-logo.png": 1390,
	"./LEND-logo.png": 1391,
	"./LINK-logo.png": 1392,
	"./MANA-logo.png": 1393,
	"./MBTC-logo.png": 1394,
	"./MKR-logo.png": 1395,
	"./MTA-logo.png": 1396,
	"./REN-logo.png": 1397,
	"./REP-logo.png": 1398,
	"./SNX-logo.png": 1399,
	"./SRM-logo.png": 1400,
	"./TUSD-logo.png": 1401,
	"./UNI-logo.png": 1402,
	"./USDC-logo.png": 1403,
	"./USDT-logo.png": 1404,
	"./WBTC-logo.png": 1405,
	"./WETH-logo.png": 1406,
	"./YFI-logo.png": 1407,
	"./ZRX-logo.png": 1408,
	"./cream-logo.png": 1409,
	"./crvBTC-logo.png": 1410,
	"./crvBUSD-logo.png": 1411,
	"./mUSD-logo.png": 1412,
	"./renBTC-logo.png": 1413,
	"./sBTC-logo.png": 1414,
	"./sUSD-logo.png": 1415,
	"./unknown-logo.png": 220,
	"./yCRV-logo.png": 1416,
	"./yDAI-logo.png": 1417,
	"./yUSD-logo.png": 1418,
	"./yWETH-logo.png": 1419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 313;